// import React from "react";
// import { classNames } from "../../helpers/classNames";

// const Cards = ({
//   children,
//   title = "Card Title",
//   description = "Card description",
//   header,
//   bodyClass,
// }) => {
//   return (
//     <div className="backdrop-blur-lg bg-white/10 border border-white/20 rounded-2xl shadow-xl transition-all duration-300 overflow-hidden">
//       {header !== false && header ? (
//         header
//       ) : (
//         <div className="px-6 py-4 border-b border-white/20 bg-white/5 backdrop-blur-sm">
//           <div className="text-lg font-semibold text-white/90">{title}</div>
//           <div className="text-sm text-white/60">{description}</div>
//         </div>
//       )}
//       <div className={classNames("p-6 text-white", bodyClass)}>{children}</div>
//     </div>
//   );
// };

// export default Cards;

import React from "react";
import { classNames } from "../../helpers/classNames";

const Cards = ({
  children,
  title = "card title",
  header,
  description = "card description",
  bodyClass,
}) => {
  return (
    <div className="rounded-md overflow-hidden hover:shadow-md border border-slate-100 flex flex-col">
      {header !== false && header ? (
        header
      ) : (
        <div className="bg-slate-100 min-h-10 px-4 py-3 -space-y-[2px]">
          <div className="font-semibold text-base">{title}</div>
          <div className="text-gray-500 text-sm">{description}</div>
        </div>
      )}
      <div className={classNames("flex-grow p-4", bodyClass)}>{children}</div>
    </div>
  );
};

export default Cards;
